export default "__VITE_ASSET__Be7XUO7G__"